import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import authService from "../../services/authService";
import { clearAuthRedirectMark } from "../../utils/authRedirectGuard";

import FullscreenLoadingOverlay from "../../components/FullscreenLoadingOverlay";

const Callback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const inFrame = window.self !== window.top;

    authService
      .handleCallback()
      .then((user) => {
        if (cancelled || inFrame || !user) {
          return;
        }

        clearAuthRedirectMark();
        navigate("/dashboard", { replace: true });
      })
      .catch((error) => {
        console.error("Authentication callback failed:", error);
        if (cancelled || inFrame) {
          return;
        }

        navigate("/login", { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <FullscreenLoadingOverlay message={t("auth.signingIn")} />;
};

export default Callback;
